import Delta from 'quill-delta';
import insertText from './insertText';
import removeText from './removeText';
import addMark from './addMark';
import setMark from './setMark';
import removeMark from './removeMark';
import insertNode from './insertNode';
import splitNode from './splitNode';
import mergeNode from './mergeNode';
import removeNode from './removeNode';
import moveNode from './moveNode';
import setNode from './setNode';
var OPERATIONS_MAP = {
  // Text operations
  insert_text: insertText,
  remove_text: removeText,
  // Mark operations
  add_mark: addMark,
  set_mark: setMark,
  remove_mark: removeMark,
  // Node operations
  insert_node: insertNode,
  split_node: splitNode,
  merge_node: mergeNode,
  remove_node: removeNode,
  move_node: moveNode,
  set_node: setNode,
  // Un-handled operations
  noop: function noop(op) {
    return console.debug('Operation type %O unsupported', op);
  }
};
export function isOperationSupported(operation) {
  return Boolean(OPERATIONS_MAP[operation.type]);
}
export default function diff(operation, editor) {
  return (OPERATIONS_MAP[operation.type] || OPERATIONS_MAP.noop)(operation, editor) || new Delta();
}